import { useCallback, useEffect, useState, useSyncExternalStore } from "react";
import { ApiError, getApiKey, subscribeApiKey } from "./client";

export interface AsyncState<T> {
  data: T | null;
  loading: boolean;
  error: ApiError | Error | null;
  reload: () => void;
}

/** Загрузка данных при монтировании и по требованию. */
export function useAsync<T>(loader: () => Promise<T>, deps: unknown[]): AsyncState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<ApiError | Error | null>(null);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    loader()
      .then((result) => {
        if (!cancelled) setData(result);
      })
      .catch((cause: unknown) => {
        if (!cancelled) setError(cause instanceof Error ? cause : new Error(String(cause)));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, nonce]);

  const reload = useCallback(() => setNonce((value) => value + 1), []);
  return { data, loading, error, reload };
}


/**
 * Личный ключ пользователя.
 *
 * Задачи запускаются только под ним — служебный токен портала на действия не
 * распространяется, поэтому экранам нужно знать про ключ реактивно.
 */
export function useApiKey(): string | null {
  return useSyncExternalStore(subscribeApiKey, getApiKey, () => null);
}
